import React, { useState } from "react";
import { api } from "../lib/api";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", phone: "", subject: "General Enquiry", message: "" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/contact", f);
      toast.success("Message sent — we'll get back within 24 hours.");
      setF({ name: "", email: "", phone: "", subject: "General Enquiry", message: "" });
    } catch { toast.error("Something went wrong."); }
  };

  return (
    <div data-testid="contact-page">
      <section className="bg-[#0F2A4A] text-white py-20">
        <div className="ae-container">
          <div className="ae-overline mb-3">Contact Us</div>
          <h1 className="text-4xl md:text-6xl font-light">Let's <span className="font-serif italic text-[#C5A059]">connect</span></h1>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="ae-container grid lg:grid-cols-2 gap-12">
          <div className="space-y-4">
            <InfoCard icon={Phone} label="Primary Phone" value="+91 90990 42472" href="tel:+919099042472" />
            <InfoCard icon={Phone} label="Alternate Phone" value="+91 83200 92044" href="tel:+918320092044" />
            <InfoCard icon={Phone} label="HR Direct" value="+91 96649 83266" href="tel:+919664983266" />
            <InfoCard icon={Mail} label="General / Jobs" value="achieversenterpriseinfo@gmail.com" href="mailto:achieversenterpriseinfo@gmail.com" />
            <InfoCard icon={Mail} label="Business Enquiry" value="HR.kuldipsinh@achieversenterprise.in" href="mailto:HR.kuldipsinh@achieversenterprise.in" />
            <InfoCard icon={MapPin} label="Head Office" value="SF-17, 2nd Floor, JP Complex, Opp. Naroda Old Police Station, Naroda, Ahmedabad – 382 330" />
            <a href="https://wa.me/919099042472" target="_blank" rel="noreferrer"
               data-testid="whatsapp-btn"
               className="ae-card p-6 flex items-center gap-4 bg-emerald-50 border-emerald-100 hover:bg-emerald-100 transition-colors">
              <MessageCircle className="w-8 h-8 text-emerald-600" />
              <div>
                <div className="text-xs uppercase tracking-wider text-emerald-700 font-semibold">WhatsApp</div>
                <div className="font-medium text-[#0F2A4A]">Chat with us instantly · +91 90990 42472</div>
              </div>
            </a>
            <div className="ae-card p-2 overflow-hidden">
              <iframe src="https://maps.google.com/maps?q=JP%20Complex%20Naroda%20Old%20Police%20Station%20Ahmedabad&t=&z=15&ie=UTF8&iwloc=&output=embed"
                title="Achievers Enterprise Head Office — Naroda, Ahmedabad" width="100%" height="280" className="rounded-xl" />
            </div>
          </div>

          <form onSubmit={submit} className="ae-card p-8 space-y-4" data-testid="contact-form">
            <h2 className="font-heading font-medium text-2xl text-[#0F2A4A] ae-gold-underline">Send a Message</h2>
            <input required placeholder="Full Name" value={f.name} onChange={e => setF({ ...f, name: e.target.value })} data-testid="c-name"
              className="w-full rounded-xl border border-slate-200 bg-slate-50 focus:bg-white focus:border-[#C5A059] outline-none px-4 py-3 text-sm" />
            <div className="grid grid-cols-2 gap-4">
              <input required type="email" placeholder="Email" value={f.email} onChange={e => setF({ ...f, email: e.target.value })} data-testid="c-email"
                className="w-full rounded-xl border border-slate-200 bg-slate-50 focus:bg-white focus:border-[#C5A059] outline-none px-4 py-3 text-sm" />
              <input placeholder="Phone" value={f.phone} onChange={e => setF({ ...f, phone: e.target.value })} data-testid="c-phone"
                className="w-full rounded-xl border border-slate-200 bg-slate-50 focus:bg-white focus:border-[#C5A059] outline-none px-4 py-3 text-sm" />
            </div>
            <select value={f.subject} onChange={e => setF({ ...f, subject: e.target.value })} data-testid="c-subject"
              className="w-full rounded-xl border border-slate-200 bg-slate-50 outline-none px-4 py-3 text-sm">
              <option>General Enquiry</option>
              <option>Hiring Requirement</option>
              <option>Job Seeker Support</option>
              <option>Partnership</option>
            </select>
            <textarea required rows={5} placeholder="Your message" value={f.message} onChange={e => setF({ ...f, message: e.target.value })} data-testid="c-message"
              className="w-full rounded-xl border border-slate-200 bg-slate-50 focus:bg-white focus:border-[#C5A059] outline-none px-4 py-3 text-sm" />
            <button className="ae-btn-primary w-full" type="submit" data-testid="c-submit">Send Message</button>
          </form>
        </div>
      </section>
    </div>
  );
}

const InfoCard = ({ icon: Icon, label, value, href }) => {
  const Comp = href ? "a" : "div";
  return (
    <Comp href={href} className="ae-card p-6 flex items-center gap-4">
      <div className="w-12 h-12 rounded-xl bg-[#C5A059]/10 flex items-center justify-center">
        <Icon className="w-5 h-5 text-[#C5A059]" />
      </div>
      <div>
        <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">{label}</div>
        <div className="font-medium text-[#0F2A4A]">{value}</div>
      </div>
    </Comp>
  );
};
